module.exports = __webpack_public_path__ + "img/DSC_2736-xs.b21903d3.png";